import {
  ITracker,
  KameleoonLogger,
} from '@kameleoon/javascript-sdk-core/browser';
import { ClientDataManager } from 'src/dataManager';

export interface VisitorActivityManagerType {}

export class VisitorActivityManager implements VisitorActivityManagerType {
  private dataManager: ClientDataManager;
  private tracker: ITracker;
  private isConsentProvided: (visitorCode: string) => boolean;

  /**
   * @param dataManager - Instance of ClientDataManager
   * @param tracker - Instance of ITracker
   * @param isConsentProvided - Function to check if consent is provided for a visitor
   * @param interval - Interval in milliseconds
   */
  constructor(
    dataManager: ClientDataManager,
    tracker: ITracker,
    isConsentProvided: (visitorCode: string) => boolean,
    interval: number,
  ) {
    KameleoonLogger.debug`CALL: new VisitorActivityManager(dataManager, tracker, isConsentProvided, interval: ${interval})`;
    this.dataManager = dataManager;
    this.tracker = tracker;
    this.isConsentProvided = isConsentProvided;

    this.setup(interval);
    KameleoonLogger.debug`RETURN: new VisitorActivityManager(dataManager, tracker, isConsentProvided, interval: ${interval})`;
  }

  private setup(interval: number): void {
    setInterval(() => {
      this.updateLastActivity();
    }, interval);
    this.updateLastActivity();
  }

  private updateLastActivity(): void {
    KameleoonLogger.debug`CALL: VisitorActivityManager.updateLastActivity()`;

    const visitorCode = this.dataManager.updateLastActivity();
    if (visitorCode) {
      this.tracker.scheduleVisitor(
        visitorCode,
        this.isConsentProvided(visitorCode),
      );
    }

    KameleoonLogger.debug`RETURN: VisitorActivityManager.updateLastActivity()`;
  }
}
